import React from 'react';

const cor = (s) => {
  if (s >= 80) return { bg: 'bg-green-500',  text: 'text-green-700',  ring: 'bg-green-100',  label: 'Excelente' };
  if (s >= 60) return { bg: 'bg-lime-500',   text: 'text-lime-700',   ring: 'bg-lime-100',   label: 'Ótimo' };
  if (s >= 40) return { bg: 'bg-yellow-500', text: 'text-yellow-700', ring: 'bg-yellow-100', label: 'Bom' };
  return               { bg: 'bg-orange-400',text: 'text-orange-700', ring: 'bg-orange-100', label: 'Moderado' };
};

export function ScoreCircle({ score, size = 'md' }) {
  const c = cor(score);
  const sizes = { sm: 'w-10 h-10 text-sm', md: 'w-14 h-14 text-base', lg: 'w-20 h-20 text-xl' };
  return (
    <div className={`${sizes[size]} ${c.ring} rounded-full flex flex-col items-center justify-center flex-shrink-0`}>
      <span className={`font-sora font-bold ${c.text} leading-none`}>{score}%</span>
      {size === 'lg' && <span className={`text-xs ${c.text} font-medium mt-0.5`}>{c.label}</span>}
    </div>
  );
}

export function ScoreBars({ scoreArea, scoreGeo }) {
  return (
    <div className="space-y-1.5 min-w-[100px]">
      <div>
        <div className="flex justify-between text-xs text-gray-400 mb-0.5">
          <span>Área (60%)</span><span className="font-medium text-gray-600">{scoreArea}%</span>
        </div>
        <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-acre-green rounded-full transition-all duration-700" style={{ width: `${scoreArea}%` }} />
        </div>
      </div>
      <div>
        <div className="flex justify-between text-xs text-gray-400 mb-0.5">
          <span>Cidade (40%)</span><span className="font-medium text-gray-600">{scoreGeo}%</span>
        </div>
        <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-blue-400 rounded-full transition-all duration-700" style={{ width: `${scoreGeo}%` }} />
        </div>
      </div>
    </div>
  );
}

export default function MatchBar({ score, scoreArea, scoreGeo }) {
  const c = cor(score);
  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full ${c.ring}`}>
      <div className={`w-2 h-2 rounded-full ${c.bg}`} />
      <span className={`font-sora font-bold text-sm ${c.text}`}>{score}%</span>
      <span className={`text-xs ${c.text}`}>{c.label}</span>
    </div>
  );
}
